import { useIntl } from "react-intl";
import { Button } from "components";
import cn from "classnames";

import { Enum_BranchesInfoRegionFilters } from "../BranchesInfo.types";

import "./BranchesInfoFilters.scss";

interface BranchesInfoFiltersProps {
  currentFilter: Enum_BranchesInfoRegionFilters;
  setCurrentFilter: (e: Enum_BranchesInfoRegionFilters) => void;
  className?: string;
}

export const BranchesInfoFilters = ({
  currentFilter,
  setCurrentFilter,
  className,
}: BranchesInfoFiltersProps) => {
  const { formatMessage } = useIntl();
  return (
    <div className={cn(className, "branches-info__filters")}>
      <Button.FilterButton
        active={currentFilter === Enum_BranchesInfoRegionFilters.all}
        onClick={() => setCurrentFilter(Enum_BranchesInfoRegionFilters.all)}
      >
        {formatMessage({
          id: "branches.filter.all",
          defaultMessage: "_branches.filter.all_",
        })}
      </Button.FilterButton>
      <Button.FilterButton
        active={currentFilter === Enum_BranchesInfoRegionFilters.tbilisi}
        onClick={() => setCurrentFilter(Enum_BranchesInfoRegionFilters.tbilisi)}
      >
        {formatMessage({
          id: "branches.filter.city",
          defaultMessage: "_branches.filter.city_",
        })}
      </Button.FilterButton>
      <Button.FilterButton
        active={currentFilter === Enum_BranchesInfoRegionFilters.regions}
        onClick={() => setCurrentFilter(Enum_BranchesInfoRegionFilters.regions)}
      >
        {formatMessage({
          id: "branches.filter.regions",
          defaultMessage: "_branches.filter.regions_",
        })}
      </Button.FilterButton>
    </div>
  );
};
